import React from 'react'
import { useParams } from 'react-router-dom'
import { getQuery } from '@vt/utils'
import OrgProvider from './hooks/org/provider'
import Users from './users'
import Role from './role'

const Index = function () {
  const { appId } = useParams()
  const { type } = getQuery()

  return (
    <div className="w-full h-full">
      {type !== '1' ? (
        <OrgProvider appId={appId}>
          <Users appId={appId} />
        </OrgProvider>
      ) : (
        <Role />
      )}
    </div>
  )
}
export default Index
